export enum DeliveryMethods {
    ETicket = "E_TICKET",
    Tod = "TOD",
}
